module.exports = __webpack_public_path__ + "img/clinic.6ca5437a.jpg";